/**
 * Represents an abstract class that provides 3D Babylon model asset links
 * and curve/path data to the node graph.
 * 
 * To use, please inherit from this class and implement your own methods as
 * desired.
 */
export default class IAssetProvider
{
	constructor()
	{

	}
	
    getNodeGraphList()
	{
        return [];
    }

    getNodeGraph(assetKey)
	{
		const procAssetList = this.getNodeGraphList(); 
		for(let pInfo of procAssetList)
		{
			// The keys may be int to string comparison
			if(pInfo['key'] == assetKey)
				return pInfo;
		}

		return null;
    }

	/** 
	 * Returns a list of objects for every 3D asset available to the system 
	 * 
	 * @return {list} A list of objects of the following form:
	 * <pre><code>
	 * {
	 *     key: the id of the model in question, can be any form
	 *     label: a string with the description of the model
	 *     tagsArray: an array containing asset tags
	 *     file: a full path to load the file from
	 * }
	 * </code></pre>
	 */
	get3DAssetList()
	{
		return [];
	}

	/**
	 *  Return the object describing a specific 3D model as determined by
	 *  the key parameter
	 * @param {any} assetKey - the id of the 3D model.
	 * @return {object} An object of the following form:
	 * <pre><code>
	 * {
	 *     key: the id of the model in question, can be any form
	 *     label: a string with the description of the model
	 *     tagsArray: an array containing asset tags
	 *     file: a full path to load the file from
	 * }
	 * </code></pre>
	 */
	get3DAsset(assetKey)
	{
		const assetList = this.get3DAssetList(); 
		for(let pInfo of assetList)
		{
			if(pInfo['key'] == assetKey)
				return pInfo;
		}

		return null;
	}

	/** 
	 * Returns a list of objects for every path available to the system 
	 * 
	 * @return {list} A list objects of the following form:
	 * <pre><code>
	 * {
	 *     key: the id of the model in question, can be any form
	 *     label: a string with the description of the model
	 *     tagsArray: an array containing asset tags
	 *     file: a full path to load the file from
	 * }
	 * </code></pre>
	 */
	getPathList()
	{
		return [];
	}

	/**
	 *  Return the object describing a specific path as determined by
	 *  the key parameter
	 * @param {any} pathKey - the id of the path.
	 * @return {object} An object of the following form:
	 * <pre><code>
	 * {
	 *     key: the id of the model in question, can be any form
	 *     label: a string with the description of the model
	 *     tagsArray: an array containing asset tags
	 *     file: a full path to load the file from
	 * }
	 * </code></pre>
	 */
	getPath(pathKey)
	{
		let pathList = this.getPathList();
		for(let pInfo of pathList)
		{
			if(pInfo['key'] == pathKey)
				return pInfo;
		}

		return null;
	}

	getMaterialList()
	{
		return [];
	}

	getMaterial(materialKey)
	{
		const matList = this.getMaterialList(); 
		for(let pInfo of matList)
		{
			if(pInfo['key'] == materialKey)
				return pInfo;
		}

		return null;
	}

	getTextureList()
	{
		return [];
	}

	getTexture(textureKey)
	{
		const textureList = this.getTextureList(); 
		for(let pInfo of textureList)
		{
			if(pInfo['key'] == textureKey)
				return pInfo;
		}

		return null;
	}
}